import { render } from "./TopicLinkTypeStatusList.vue?vue&type=template&id=1f3e6272&scoped=true"
import script from "./TopicLinkTypeStatusList.vue?vue&type=script&lang=js"
export * from "./TopicLinkTypeStatusList.vue?vue&type=script&lang=js"

import "./TopicLinkTypeStatusList.vue?vue&type=style&index=0&id=1f3e6272&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3e6272"]])

export default __exports__